import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormInputContainer from "@babackapp/react-hook-forms-components/form-input-container";
import { Button } from "@babackapp/ui/components/button";
import { FormField } from "@babackapp/ui/components/form";
import { PlusIcon, TrashIcon } from "@radix-ui/react-icons";
import { useFieldArray, useFormContext } from "react-hook-form";
import { CustomerPortalFormValues } from "./customer-portal-basics-card";
import useTranslation from "@babackapp/translations/use-translation";

type MetafieldFormProps = {
  name: string;
  label: string;
  description: string;
  disabled?: boolean | string;
};

export default function MetafieldForm(props: MetafieldFormProps = {}) {
  const t = useTranslation();

  const { control } = useFormContext<CustomerPortalFormValues>();

  const tags = useFieldArray({
    control,
    name: props.name,
  });

  const onAddTag = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    tags.append({
      key: "",
      value: "",
    });
  };

  return (
    <FormInputContainer
      label={props.label}
      description={props.description}
      disabled={props.disabled}
    >
      <div className="flex flex-col gap-2">
        {tags.fields.map((tag, index) => (
          <div key={tag.id} className="flex gap-2 items-end justify-end">
            <FormField
              control={control}
              name={`${props.name}.${index}.key`}
              render={({ field }) => (
                <FormInput
                  selectAllOnFocus
                  label={t(
                    "settings.customerPortal.basics.fields.nonReturnableMetafieldItems.fields.key",
                  )}
                  {...field}
                />
              )}
            />
            <FormField
              control={control}
              name={`${props.name}.${index}.value`}
              render={({ field }) => (
                <FormInput
                  selectAllOnFocus
                  label={t(
                    "settings.customerPortal.basics.fields.nonReturnableMetafieldItems.fields.value",
                  )}
                  {...field}
                />
              )}
            />
            <div>
              <Button
                role="button"
                variant="outline"
                size="icon"
                onClick={() => tags.remove(index)}
              >
                <TrashIcon className="size-4" />
              </Button>
            </div>
          </div>
        ))}
        <div className="flex justify-start">
          <Button
            role="button"
            className="flex gap-2 justify-self-start"
            size="sm"
            variant="outline"
            onClick={onAddTag}
          >
            {t(
              "settings.customerPortal.basics.fields.nonReturnableMetafieldItems.addTag",
            )}
            <PlusIcon className="size-4" />
          </Button>
        </div>
      </div>
    </FormInputContainer>
  );
}
